import React, {useContext} from 'react';
import isEmpty from 'lodash/isEmpty';
import {scaleOrdinal} from 'd3';

import {TreeMap} from 'components';

import styles from './Treemap.module.scss';

import Context from '../../context';
import {createDataTree, DEVICES} from '../../helpers';
import {TREEMAP_COLORS, TREEMAP_DOMAIN, VIEW_ONLINE} from '../../constants';
import imgNoData from '../../assets/treemap-no-data.png';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import {withResponsive} from '../../hocs';

const methods = {
  default: v => v,
  logarithmic: v => 1000 * Math.log10(v),
  squareRoot: v => 333 * Math.sqrt(v),
};

const color = scaleOrdinal(TREEMAP_COLORS).domain(TREEMAP_DOMAIN);

const widths = {
  [DEVICES.DESKTOP]: 1250,
  [DEVICES.LAPTOP]: 800,
  [DEVICES.TABLET]: 500,
  [DEVICES.MOBILE]: 300,
};

export const TreemapComponent = ({device}) => {
  const {dataTable, viewmode} = useContext(Context);
  const dataTree = createDataTree(dataTable);
  const width = widths[device];

  const divStyle = {
    display: viewmode === VIEW_ONLINE ? 'block' : 'none',
  };

  return (
    <div className={styles.wrap} style={divStyle}>
      {isEmpty(dataTree.children) ? (
        <div className={styles.noData}>
          <h3>No online groups with these criteria</h3>
          <img src={imgNoData} alt="No data" />
        </div>
      ) : (
        <TreeMap
          color={color}
          height={400}
          width={width}
          data={dataTree}
          sumFunc={methods.squareRoot}
        />
      )}
    </div>
  );
};

export const Treemap = withResponsive(TreemapComponent);

TreemapComponent.propTypes = {
  device: PropTypes.oneOf(values(DEVICES)),
};

TreemapComponent.defaultProps = {
  device: DEVICES.DESKTOP,
};
